import { getStunChoice } from "./getStunChoice";
export function getWebRTCConfiguration(roomId, credentials) {
    const stunChoice = getStunChoice(roomId);
    return {
        iceServers: [
            { urls: [`stun:${stunChoice}.sd-sfr.fr:443`] },
            {
                urls: [
                    `turn:${stunChoice}.sd-sfr.fr:443`,
                    `turns:${stunChoice}.sd-sfr.fr:443`
                ],
                username: credentials.user,
                credential: credentials.password
            }
        ]
    };
}
